import AXIOS from "@/axios";
import { removeEmptyProps } from "@/utils/constants";
import { APIResponse } from "@/types/user.model";

export type EmailListQuery = {
  page?: number;
  pageSize?: number;
  search?: string;
  projectId?: string;
  clientId?: string;
  scenario?: string;
  status?: string;
  fromDate?: string;
  toDate?: string;
};

export const getEmailListService = (query: EmailListQuery) => {
  return AXIOS.get("/project/v1/email/list", {
    params: removeEmptyProps(query),
  });
};

export const getScenariosListService = () => {
  // Returns strings like "Project expired", "Out of hours", etc.
  return AXIOS.get<APIResponse<string[]>>("/base/dn/v1/scenarios/all");
};

export type EmailTemplateData = {
  scenario: string;
  subject: string;
  template_name: string;
  body: string;
};

export const getEmailTemplateService = (
  scenario: string,
  projectId: string
) => {
  return AXIOS.get<APIResponse<EmailTemplateData>>("/project/v1/email-template", {
    params: { scenario, projectId },
  });
};

export type ProjectMailSendPayload = {
  project_id: string;
  client_id: string;
  scenario: string;
  esti_hrs: number;
  util_hrs: number;
  remi_hrs: number;
  end_date: string; // e.g. "24122026"
  to: string[];
  cc: string[];
  bcc: string[];
  subject: string;
  body: string; // HTML string
  action: "send_now" | "send_later";
};

export const sendProjectEmailService = (
  projectId: string,
  payload: ProjectMailSendPayload
) => {
  return AXIOS.post(`/project/v1/mail/send/${projectId}`, payload);
};

export const resendFailedEmailService = (
  emailId: string,
  payload: ProjectMailSendPayload
) => {
  return AXIOS.post(`/project/v1/mail/resend/${emailId}`, payload);
};

export type OnboardEmailPayload = {
  action: "send_now" | "send_later";
  to: string[];
  cc: string[];
  bcc: string[];
  subject: string;
  body: string; // HTML string
};

export const sendOnboardEmailService = (
  clientId: string,
  payload: OnboardEmailPayload
) => {
  return AXIOS.post(`/user/v1/onboardemail/${clientId}`, payload);
};

export type EmailLogClient = {
  id: string;
  name: string;
  org_name?: string;
};

export type EmailLogProject = {
  id: string;
  name: string;
  client?: EmailLogClient;
  esti_hrs?: number;
  util_hrs?: string | number;
  remi_hrs?: string | number;
  start_date?: string;
  end_date?: string;
  status?: string;
  status_color_code?: string;
  project_type?: string;
  warning?: boolean;
};

export type EmailLogDetail = {
  id: string;
  client: EmailLogClient;
  project: EmailLogProject;
  scenario: string;
  status: "sent" | "failed" | "active";
  send_date: string | null;
  send_time: string | null;
  subject: string;
  body: string;
  error: string | null;
  to: string[];
  cc: string[];
  bcc: string[];
};

export const getEmailViewService = (emailId: string) => {
  return AXIOS.get<APIResponse<EmailLogDetail>>(`/project/v1/email/view/${emailId}`);
};
